import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import Input from '../../components/Input'
import { useAuth } from '../../providers/Auth'
import { useNotification } from '../../providers/Notification'
import './style.scss'
import { Login } from '../../graphql/mutations'
import { useMutation } from '@apollo/client'

const LoginScreen = () => {

    const { user, signIn } = useAuth()
    const { dispatch } = useNotification()
    const navigate = useNavigate()
    const [username, setUsername] = useState()
    const [password, setPassword] = useState()
    const [logInWithPassword] = useMutation(Login)

    useEffect(() => {
        if (user) {
            navigate('/', {
                replace: true,
            })
        }
    }, [])

    const login = async () => {
        const res = await logInWithPassword({
            variables: {
                username,
                password,
            },
        })

        if (!res?.data?.login) {
            dispatch({
                type: 'ADD',
                payload: {
                    type: 'error',
                    content: 'Invalid credentials',
                },
            })
            return
        }

        signIn(res.data.login)
        dispatch({
            type: 'REMOVE_ALL',
        })
    }

    const handleEnter = ({ key }) => {
        if (key === 'Enter') login()
    }

    return (
        <div className='login'>
            <div className='inner'>
                <div className='brand'>
                    <div className='brand-logo'></div>
                </div>
                <Input
                    label={t('Username')}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <Input
                    label={t('Password')}
                    type={'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyUp={handleEnter}
                />
                <div className='login-actions'>
                    <Button
                        label={t('Sign in')}
                        onClick={login}
                    />
                </div>
            </div>
        </div>
    )
}

export default LoginScreen